import React, { useState } from 'react';
import classNames from 'classnames';
import useOutsideClick from 'shared/lib/useOutsideClick';

const Dropdown = ({
  children,
  name,
  extraMainClass,
  klass = 'btn-form btn-link',
  icon = 'chevron',
  withFinish = true
}) => {

  const [open, setOpen] = useState(false);

  const mainClass = classNames(
    'shared-dropdown',
    extraMainClass,
    {
      'open': open,
    }
  );

  const linkClass = classNames(
    'btn',
    'shared-dropdown__link',
    `shared-dropdown__link--${icon}`,
    klass
  );

  const finish = () => open && setOpen(false);

  const Name = () => {
    if(typeof name === 'function'){
      const NameComponent = name;
      return <NameComponent />;
    }

    return name;
  }

  const renderList = () => {
    return (<div className="shared-dropdown__list">
      {children.filter(child => !!child).map((child, i) => {
        return <child.type {...child.props} {...(withFinish ? { onFinish: finish } : {} )} key={i}/>
      })}
    </div>);
  }

  return (
    <div className={mainClass} ref={useOutsideClick(() => setOpen(false))}>
      <a className={linkClass} onClick={() => setOpen(!open)}>
        <Name />
        {icon === 'caret' && <span className="caret" />}
      </a>
      {open && renderList()}
    </div>
   );
}

export default Dropdown;
